import apiCall from '@/repository'
import firebase from 'firebase/app';
import "firebase/auth";

class AuthService {
    baseUrl = '/v1/auth';

    login = async (email, password) => {
        await firebase.auth().signInWithEmailAndPassword(email, password);

        return apiCall.post(`${this.baseUrl}/login`, {
            email,
            password
        });
    }

    sendRecoverPasswordEmail = (email) => {
        let language = navigator.language || navigator.userLanguage;
        language = language.split('-')[0];

        return apiCall.post(`${this.baseUrl}/password/recover`, {
            email,
            language
        });
    }

    refreshToken = (refreshToken) => {
        return apiCall.post(`${this.baseUrl}/refreshToken`, { refreshToken });
    }
}

export default new AuthService();



// WEBPACK FOOTER //
// ./src/services/auth.js